module.exports = __webpack_public_path__ + "static/media/Heroku.16a7dde8.svg";